import { Box, Typography } from '@capitalise/ui-design-system';
import CircleBox from 'modules/Business/components/CircleBox';
import useMediaQuery from 'modules/Business/hooks/useMediaQuery';
import PropTypes from 'prop-types';

const ProductInfo = ({ icon, value, label }) => {
  const { isMobile } = useMediaQuery();

  return (
    <Box display="flex" alignItems="center" marginRight={{ md: '3xsmall', default: '0' }}>
      {!isMobile && (
        <CircleBox backgroundColor="grey-50" size="medium" mr="tiny">
          {icon}
        </CircleBox>
      )}
      <Box display="flex" flexDirection="column" height={{ lg: 'auto', default: '100%' }}>
        <Typography size="heading-14">{value}</Typography>
        <Typography size="caption-12">{label}</Typography>
      </Box>
    </Box>
  );
};

ProductInfo.propTypes = {
  icon: PropTypes.any,
  value: PropTypes.string,
  label: PropTypes.string,
};

export default ProductInfo;
